import React, { useEffect, useState } from 'react'
import { getUserData } from './api/signIn'
import { App } from './App'

import logo from './img/icon.webp'

export function AuthProvider(): React.ReactElement {
	const [loading, setIsLoading] = useState(true)

	async function fetchUserData() {
		await getUserData()

		setIsLoading(false)
	}

	useEffect(() => {
		void fetchUserData()
	}, [])

	if (loading) {
		return (
			<div style={{
			    display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100%',
				padding: '5%'
			}}>
				<img
					src={logo}
					alt="project logo"
					style={{
					    minWidth: '250px',
						width: '20%',
						height: 'auto'
					}}
				/>
			</div>
		)
	}

	return <App />
}
